export default __webpack_public_path__ + "static/media/Belt of the Strange Beyond.2f03e022.jpg";